import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import styled from "@emotion/styled"
import GridWrapper from "../../atoms/GridWrapper"
import RowGrid from "../../atoms/RowGrid"
import Text from "../../atoms/LinkText"
import { colors } from "../../constants"

const HGrid = styled(Grid)({
  padding: "0 10px",
  "@media (max-width:540px)": {
    padding: "0 5px",
  },
})

export default class Top extends Component {
  render() {
    return (
      <RowGrid display={"inline-flex"}>
        <HGrid item>
          <Text color={colors.brand} to={"/seminar"}>
            Seminar
          </Text>
        </HGrid>
        <HGrid item>
          <Text color={colors.brand} to={"/members"}>
            Members
          </Text>
        </HGrid>
        <HGrid item>
          <Text color={colors.brand} to={"/projects"}>
            Projects
          </Text>
        </HGrid>
        <HGrid item>
          <Text color={colors.brand} to={"/selection"}>
            Selection
          </Text>
        </HGrid>
      </RowGrid>
    )
  }
}
